import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef } from 'react';
import defaultStyles from './styles/Select.module.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Checkbox } from '../checkbox/Checkbox.js';
import { omit } from '../../utils/omit.js';

const Option = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    disabled,
    isMultipleMode,
    value: propValue,
    children: propChildren,
    valueActive,
    valueSelect,
    label,
    onMouseEnter,
    onMouseLeave,
    onClickOption,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const value = 'value' in props ? propValue : `${propChildren}`;
  const childNode = 'children' in props ? propChildren : `${label}`;
  const isChecked = isMultipleMode ? valueSelect.indexOf(label) !== -1 : valueSelect === label;
  const isHovered = value === valueActive;
  const optionLabelProps = {
    className: clsx(isMultipleMode ? styles.option_wrapper : styles.option, {
      [styles.option_selected]: isChecked,
      [styles.option_disabled]: disabled,
      [styles.option_hover]: isHovered,
      [styles.option_empty]: !childNode && childNode !== 0
    }),
    onMouseEnter: () => onMouseEnter && onMouseEnter(value),
    onMouseLeave: () => onMouseLeave && onMouseLeave(),
    onClick: event => {
      onClickOption && onClickOption(value, disabled, label);
      rest.onClick && rest.onClick(event);
    },
    ...omit(rest, ['_key', 'extra', 'isSelectOption', 'onClick', 'onMouseEnter', 'onMouseLeave'])
  };
  if (isMultipleMode) {
    return /*#__PURE__*/jsxs("li", {
      ref: ref,
      ...optionLabelProps,
      children: [/*#__PURE__*/jsx(Checkbox, {
        theme: {
          root: styles.select_checkbox
        },
        checked: isChecked,
        disabled: disabled,
        onChange: optionLabelProps.onClick
      }), typeof childNode === 'string' ? /*#__PURE__*/jsx("div", {
        className: styles.option_content,
        children: childNode
      }) : childNode]
    });
  }
  return /*#__PURE__*/jsx("li", {
    ref: ref,
    ...optionLabelProps,
    children: /*#__PURE__*/jsx("div", {
      className: styles.option_content,
      children: childNode
    })
  });
});
Option.defaultProps = {
  isSelectOption: true
};
Option.displayName = 'Option';

export { Option };
